export const SHOW_PORTFOLIO = 'SHOW_PORTFOLIO',CLOSE_PORTFOLIO = 'CLOSE_PORTFOLIO'